import React from 'react';
import { useLocation } from 'react-router';

export const useRouteQuery = () => {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
};
